﻿import { faCalculator } from '@fortawesome/pro-duotone-svg-icons';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormInstance, Space, Tooltip } from 'antd';
import InputNumberExt from 'msg-ui-react/dist/components/data-entry/InputNumberExt';
import React, { useEffect, useRef } from 'react';
import { IChartWmsState } from '../../models/ChartModels';
import { ChartWmsStore } from '../../stores/ChartWmsStore';

var focusTimeout: number | undefined;

interface Props {
    form: FormInstance<IChartWmsState>,
    state: IChartWmsState,
    store?: ChartWmsStore,
    onChange?: (value: number) => void,
    value?: number,
    width?: number
}

export const SafetyDepthComponent: React.FC<Props> = ({
    form,
    state,
    store,
    value,
    onChange,
    width
}) => {
    const input = useRef<HTMLInputElement>(null);

    useEffect(() => {
        return () => window.clearTimeout(focusTimeout);
    }, []);    

    useEffect(() => {
        if (value != undefined) 
            form.validateFields(['safetyDepth']);        
    }, [value, form]);    

    const onChangeInternal = (changedValue: number) => {
        if (onChange && !state.safetyDepthIsCalculated)       
            onChange(changedValue);
    }

    const onClick = () => {
        const safetyDepthIsCalculated = !state.safetyDepthIsCalculated;
        if (store) {
            store?.setState({ safetyDepthIsCalculated });
            if (!safetyDepthIsCalculated) {
                window.clearTimeout(focusTimeout);
                focusTimeout = window.setTimeout(() => {
                    input.current?.focus();
                }, 200);
            }
        }
    }

    const getTooltip = () => `Use ${state.safetyDepthIsCalculated ? 'fixed' : 'calculated'} value`;
    const getIcon = () => state.safetyDepthIsCalculated ?
        <FontAwesomeIcon icon={faCalculator} fixedWidth transform="grow-3" /> :
        <FontAwesomeIcon icon={faPen} fixedWidth />

    return (
        <Space direction='horizontal' wrap={false} size={4}>
            <InputNumberExt ref={input}
                readOnly={state.safetyDepthIsCalculated}
                step={0.1} precision={1} addonAfter='m'
                value={value} onChange={onChange} style={{width}}
            />
            <Tooltip title={getTooltip} placement='topRight' arrowPointAtCenter={true} mouseEnterDelay={1} >
                <Button type="default" size='middle' onClick={onClick} icon={getIcon()} />
            </Tooltip>
        </Space>
    )
}

export default SafetyDepthComponent;